import LineIcon from '@/components/base/LineIcon';

export default function ContactSection() {
  return (
    <section id="contact" className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          alt="京都の落ち着いた街並み"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20Kyoto%20traditional%20wooden%20facade%20at%20golden%20hour%20with%20subtle%20lantern%20light%2C%20muted%20warm%20neutral%20tones%2C%20calm%20trustworthy%20professional%20atmosphere%2C%20editorial%20photography%20style%2C%20simple%20clean%20background%2C%20high%20detail%20cinematic%20composition&width=1920&height=900&seq=yoshikawa-contact-bg-01&orientation=landscape"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/85 to-foreground-950/90" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="font-mincho text-primary-300 tracking-widest text-sm md:text-base mb-3">
            CONTACT
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-background-50 leading-snug">
            まずは<span className="text-primary-400">無料相談</span>から
          </h2>
          <p className="mt-5 text-background-50/85 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            京都 不用品回収・京都 遺品整理・古紙回収・資源回収、
            どんなご相談も無料でお受けします。お気軽にお問い合わせください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          <a
            href="tel:+81120219620"
            className="group p-8 rounded-lg bg-background-50 hover:bg-background-100 border border-background-200 cursor-pointer transition-colors"
          >
            <div className="flex items-center gap-4 mb-5">
              <div className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
                <span className="w-7 h-7 flex items-center justify-center text-2xl">
                  <i className="ri-phone-fill" />
                </span>
              </div>
              <div>
                <p className="text-xs text-foreground-500 tracking-widest mb-1">
                  お電話でのお問い合わせ
                </p>
                <p className="text-2xl md:text-3xl font-mincho font-bold text-foreground-950">
                  0120-219-620
                </p>
              </div>
            </div>
            <div className="pt-5 border-t border-background-200 text-sm text-foreground-700 space-y-1">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-time-line" />
                </span>
                受付 9:00〜17:00 / 年中無休
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-truck-line" />
                </span>
                京都市・京都府全域 即日対応可能
              </p>
            </div>
          </a>

          <a
            href="https://lin.ee/yKaHc4I"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-8 rounded-lg bg-accent-700 hover:bg-accent-800 cursor-pointer transition-colors"
          >
            <div className="flex items-center gap-4 mb-5">
              <div className="w-14 h-14 flex items-center justify-center rounded-md bg-background-50 text-accent-700">
                <LineIcon className="w-6 h-6 shrink-0" />
              </div>
              <div>
                <p className="text-xs text-background-50/85 tracking-widest mb-1">
                  LINEでのお問い合わせ
                </p>
                <p className="text-2xl md:text-3xl font-mincho font-bold text-background-50">
                  LINEで無料見積り
                </p>
              </div>
            </div>
            <div className="pt-5 border-t border-background-50/30 text-sm text-background-50/95 space-y-1">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-image-line" />
                </span>
                写真を送るだけで概算お見積り
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line" />
                </span>
                24時間受付 / ご返信は営業時間内
              </p>
            </div>
          </a>
        </div>

        <div className="mt-10 text-center text-background-50/75 text-xs md:text-sm">
          <p>
            法人・不動産会社様のお見積り依頼、継続対応のご相談もお電話・LINEにて承ります。
          </p>
        </div>
      </div>
    </section>
  );
}